import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'videoPoster',
})
export class VideoPosterPipe implements PipeTransform {
    transform(videoUrl: string): Promise<string> {
        return new Promise((resolve) => {
            if (!videoUrl) {
                resolve('');
                return;
            }

            const video = document.createElement('video');
            video.crossOrigin = 'anonymous'; // Wajib biar nggak kena error CORS dari BE
            video.src = videoUrl;
            video.muted = true;
            video.setAttribute('playsinline', 'true');
            video.preload = 'metadata';

            video.addEventListener('loadedmetadata', () => {
                video.currentTime = 0.1; // Geser dikit cari frame yang jelas
            });

            video.addEventListener('seeked', () => {
                try {
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');

                    // Tentukan lebar maksimal thumbnail biar memori gak jebol
                    const MAX_WIDTH = 320;
                    let width = video.videoWidth;
                    let height = video.videoHeight;

                    // Kalkulasi rasio ukuran baru
                    if (width > MAX_WIDTH) {
                        height = Math.floor(height * (MAX_WIDTH / width));
                        width = MAX_WIDTH;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    if (context) {
                        // Gambar ulang dengan ukuran yang udah di-scale down
                        context.drawImage(video, 0, 0, width, height);

                        // Convert ke Base64 dengan kualitas 70%
                        resolve(canvas.toDataURL('image/jpeg', 0.7));
                    } else {
                        resolve('');
                    }
                } catch (e) {
                    resolve('');
                }
            });

            video.addEventListener('error', () => {
                resolve('');
            });
        });
    }
}
